
import Vue from 'vue'
import Vuetify from 'vuetify'
import Router from 'vue-router'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'vuetify/dist/vuetify.min.css'
import Vuex from 'vuex'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free'
import '@fortawesome/fontawesome-free/css/all.css'
import 'focus-visible/dist/focus-visible.min.js'
import VueTheMask from 'vue-the-mask'
import VueSweetalert2 from 'vue-sweetalert2';
import store from './vuex/store'
import moment from 'moment'
// import $ from 'jquery'
import money from 'v-money'
import App from './App.vue'
import VueTour from 'vue-tour'
import VuexStore from '@/vuex/store'
import vueMask from 'vue-jquery-mask';
import VueMousetrap from 'vue-mousetrap'
import Cookies from 'js-cookie'

Vue.use(VueMousetrap)
// import Cleave from 'cleave.js'
window.$ = require('jquery')
window.JQuery = require('jquery')
Vue.config.productionTip = false
Vue.use(money, {precision: 4})
Vue.use(Router)
Vue.use(Vuex)
Vue.use(Vuetify)
Vue.use(VueTheMask)
Vue.use(VueSweetalert2)
Vue.use(VueTour)
Vue.use(vueMask);
Vue.use(Cookies)

import routes from './router'
require('./assets/css/style.css')
require('./assets/css/flex.css')
require('vue-tour/dist/vue-tour.css')
Vue.filter('formataData', function (data, formato) {
  if (!data) return ''
  formato = formato || 'DD/MM/YYYY'
  return moment(data.replace(' 00:00:00', '')).locale('pt').format(formato)
})
Vue.filter('formataValor', function (value) {
  if (isNaN(value)) {
    return formataNumero(0, 2, ',', '.')
  } else {
    return formataNumero(value, 2, ',', '.')
  }
 })
 function formataNumero (number, decimals, decPoint, thousandsSep) {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
  var n = !isFinite(+number) ? 0 : +number
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  var s = ''
  var toFixedFix = function (n, prec) {
    var k = Math.pow(10, prec)
    return '' + (Math.round(n * k) / k).toFixed(prec)
  }
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
 }
 (function () {
  var Contrast = {
      storage: 'contrastState',
      cssClass: 'contrast',
      currentState: null,
      check: checkContrast,
      getState: getContrastState,
      setState: setContrastState,
      toogle: toogleContrast,
      updateView: updateViewContrast
  };

  window.toggleContrast = function () { Contrast.toogle(); };

  Contrast.check();

  function checkContrast() {
      this.updateView();
  }

  function getContrastState() {
      return sessionStorage.getItem(this.storage) === 'true';
  }

  function setContrastState(state) {
      sessionStorage.setItem(this.storage, '' + state);
      this.currentState = state;
      this.updateView();
  }

  function updateViewContrast() {
      var body = document.body;

      if (this.currentState === null)
          this.currentState = this.getState();

      if (this.currentState)
          body.classList.add(this.cssClass);
      else
          body.classList.remove(this.cssClass);
  }

  function toogleContrast() {
      this.setState(!this.currentState);
  }
})();

( function() {
    window.fonte = function(e){fonte(e)};
    function fonte(e) {
        let lista = document.querySelectorAll(".acessibilidade")
        if( e == 'a') {
          if(VuexStore.state.fonte <= 0) VuexStore.commit('SET_FONTE', 10)
          else VuexStore.commit('SET_FONTE', 0)
        }
        else if(e == 'd') {
          if(VuexStore.state.fonte >= 0) VuexStore.commit('SET_FONTE', -10)
          else VuexStore.commit('SET_FONTE', 0)
        } 
        for(let i=0; i<lista.length; i++){
            let elemento = lista[i]
            let fonte = parseInt(window.getComputedStyle(elemento, null).getPropertyValue("font-size"))
            let temp = fonte + VuexStore.state.fonte
            if(temp>=12 && temp <=40){
                elemento.style.fontSize = temp + 'px'
            }
        }	
    }
})();
const router = new Router({routes})
router.beforeEach((to,from, next)=>{
  if(to.path !== '/' && to.path !== '/@login' && to.name !== 'documentosMenu') {
    if(sessionStorage.getItem('TOKEN') === '' || sessionStorage.getItem('TOKEN') === null){
      router.push({name: 'login'})
    } else {
      next()
    }
  } else {
    next()
  }
})
new Vue({
  el: '#app',
  router: router,
  store: store,
  render: h => h(App)
})